import { Map } from 'immutable';

import {
  FETCH_COMMISIONINGS_TYPES_REQUEST,
  FETCH_COMMISIONINGS_TYPES_SUCCESS,
  FETCH_COMMISIONINGS_TYPES_FAILURE,
} from './action';

const initialState = Map({
  type: '',
  payload: [],
});

function reducer(state = initialState, action) {
  const { type } = action;

  if (type === FETCH_COMMISIONINGS_TYPES_REQUEST) {
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => true)
      .updateIn(['isLoaded'], () => false)
      .setIn(['payload'], []);
  }

  if (type === FETCH_COMMISIONINGS_TYPES_FAILURE) {
    const { payload } = action;
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => false)
      .updateIn(['isLoaded'], () => false)
      .setIn(['payload'], payload);
  }

  if (type === FETCH_COMMISIONINGS_TYPES_SUCCESS) {
    const { payload } = action;
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => false)
      .updateIn(['isLoaded'], () => true)
      .setIn(['payload'], payload);
  }

  return state;
}

export default reducer;
